import styled from 'styled-components';

export const StyledCardHeader = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const UnstyledButton = styled.button`
  background: none;
  font-size: ${({ theme }) => theme.font.size.xxsmall};
`;
